export const environment = {
  production: false,
  apiUrl: 'https://apidev.hpsiapp.com/api',
  version: '0.0.1',
  buildDate: new Date().toISOString(),
  appName: 'HPSI Main',
  appDescription: 'HPSI Main Application',
  appLogoUrl: '/assets/logo.png',
  appFaviconUrl: '/assets/favicon.ico',
  msalConfig: {
    auth: {
      clientId: '7292bcf4-0f80-4d32-9efa-c0f7ebea8a39',
      redirectUri: window.location.origin + '/',
      authority:
        'https://login.microsoftonline.com/7efed6a4-2aee-4f44-b221-480b58526176',
    },
  },
  apiConfig: {
    scopes: [],
  },
};
